
const serach = () => import(/* webpackChunkName: "page-search" */ '@/views/page/serach.vue');
const notice = () => import(/* webpackChunkName: "page-notice" */ '@/views/page/notice.vue');
const image = () => import(/* webpackChunkName: "page-image" */ '@/views/page/image.vue');
const lottery = () => import(/* webpackChunkName: "page-lottery" */ '@/views/page/lottery/index.vue');
const history = () => import(/* webpackChunkName: "page-lottery-history" */ '@/views/page/lottery/history.vue');
const playback = () => import(/* webpackChunkName: "page-lottery-playback" */ '@/views/page/lottery/playback.vue');
const playDesc = () => import(/* webpackChunkName: "page-lottery-play-desc" */ '@/views/page/lottery/playDesc.vue');
const historyDesc = () => import(/* webpackChunkName: "page-lottery-history-desc" */ '@/views/page/lottery/historyDesc.vue');

const materials = () => import(/* webpackChunkName: "page-materials" */ '@/views/page/materials/index.vue')
const list = () => import(/* webpackChunkName: "page-materials-list" */ '@/views/page/materials/list.vue')
const search = () => import(/* webpackChunkName: "page-materials-search" */ '@/views/page/materials/search.vue')
const details = () => import(/* webpackChunkName: "page-materials-details" */ '@/views/page/materials/details.vue')
const commentsc = () => import(/* webpackChunkName: "page-materials-comment" */ '@/views/page/materials/comment.vue')
const materialsHistory = () => import(/* webpackChunkName: "page-materials-history" */ '@/views/page/materials/history.vue');

const pageRoute = [

    {
        path: '/serach',
        name: 'serach',
        component: serach,
        meta: {
            keepAlive: true,
            top:true,
        },
    },
    {
        path: '/notice',
        name: 'notice',
        component: notice
        
    },
    {
        path: '/image',
        name: 'image',
        component: image,
        meta: {
            keepAlive: true,
            top:true,
          },
        
    },
    {
        path: '/lottery',
        name: 'lottery',
        meta: {
            keepAlive: true,
          },
        component: lottery
    },
    {
        path: '/lottery/history',
        name: 'history',
        component: history
    },
    {
        path: '/lottery/playback',
        name: 'playback',
        component: playback,
        meta:{
            keepAlive: true,
            scrollTo:true
        }
    },
    {
        path: '/lottery/playback/details',
        name: 'playDesc',
        component: playDesc
    },
    {
        path: '/lottery/history/details',
        name: 'historyDesc',
        component: historyDesc
    },
    
    

    {
        path: '/materials',
        name: 'materials',
        component: materials,  
        meta: {
            keepAlive: true,
            top:true,
        },
    },
    {
        path: '/materials/list',
        name: 'list',
        component: list,
        meta: {
            keepAlive: true,
            top:true,
        },
    },
    {
        path: '/materials/list/search',
        name: 'search',
        component: search,
        meta: {
         
            top:true,
        },
    },
    {
        path: '/materials/list/details',
        name: 'details',
        component: details,
        meta: {
            keepAlive: true,
            top:true,
        },
       
    },
    {
        path: '/materials/list/comment',
        name: 'materialscomments',
        component: commentsc,
        meta:{
            needLogin: true,
            top:true,
        }
    },
    {
        path: '/materials/list/history',
        name: 'materialsHistory',
        component: materialsHistory,
        meta:{
            top:true,
        }
    },

      
    
    
]


export default pageRoute
